import { useEffect, useState } from "react";
import { Megaphone, Clover } from "lucide-react";
import api from "@/lib/api";

export default function Banner() {
  const [data, setData] = useState({ enabled: false, messages: [] });

  useEffect(() => {
    let active = true;
    const load = () => api.get("/banner").then((r) => { if (active) setData(r.data); }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { active = false; clearInterval(t); };
  }, []);

  const messages = (data.messages || []).filter(Boolean);
  if (!data.enabled || messages.length === 0) return null;

  const sequence = [...messages, ...messages];

  return (
    <div
      className="ant-marquee relative overflow-hidden border-b border-[#00E676]/25 bg-[#0A100C]"
      data-testid="announcement-banner"
    >
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-[#00E676]/[0.06] via-transparent to-[#00E676]/[0.06]" />
      <div className="max-w-7xl mx-auto flex items-center relative">
        <div className="relative shrink-0 flex items-center gap-2 px-4 py-2.5 font-black text-xs uppercase tracking-wider text-[#04180a] bg-gradient-to-r from-[#39FF14] to-[#00E676] shadow-[0_0_20px_rgba(0,230,118,0.35)]">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#04180a]/50" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#04180a]" />
          </span>
          <Megaphone size={14} /> Infos
        </div>
        <div className="relative flex-1 overflow-hidden py-2.5">
          <div className="pointer-events-none absolute left-0 top-0 h-full w-14 bg-gradient-to-r from-[#0A100C] to-transparent z-10" />
          <div className="pointer-events-none absolute right-0 top-0 h-full w-14 bg-gradient-to-l from-[#0A100C] to-transparent z-10" />
          <div className="ant-marquee-track">
            {sequence.map((m, i) => (
              <span key={i} className="mx-6 inline-flex items-center gap-2 text-sm font-semibold text-[#E7F5EC]">
                <Clover size={15} className="text-[#39FF14] shrink-0" />
                {m}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
